import { render, staticRenderFns } from "./ResearchIdList.vue?vue&type=template&id=c0d155b6&scoped=true&"
import script from "./ResearchIdList.vue?vue&type=script&lang=ts&"
export * from "./ResearchIdList.vue?vue&type=script&lang=ts&"
import style0 from "./ResearchIdList.vue?vue&type=style&index=0&id=c0d155b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d155b6",
  null
  
)

export default component.exports